/**
 * KpiTable (source=events, type=kpi_table). Backend:
 * { chart: 'table', rows: [{name, actions, customers, actions_delta_pct, customers_delta_pct}] }
 */
import React from 'react';
import { Table, TableContainer, Thead, Tbody, Tr, Th, Td, Text, Badge } from '@chakra-ui/react';

function deltaCell(d) {
  if (d == null) return <Text as="span" color="gray.400">—</Text>;
  const up = d >= 0;
  return (
    <Badge colorScheme={up ? 'green' : 'red'} fontSize="2xs">
      {up ? '▲' : '▼'} {Math.abs(d).toFixed(1)}%
    </Badge>
  );
}

export default function KpiTable({ data }) {
  const rows = data?.rows || [];
  return (
    <TableContainer maxH="400px" overflowY="auto">
      <Table size="sm" variant="simple">
        <Thead position="sticky" top={0} bg="white" zIndex={1}>
          <Tr>
            <Th>Event</Th>
            <Th isNumeric>Actions</Th>
            <Th isNumeric>Δ WoW</Th>
            <Th isNumeric>Customers</Th>
            <Th isNumeric>Δ WoW</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((r) => (
            <Tr key={r.name}>
              <Td fontSize="xs">{r.name}</Td>
              <Td fontSize="xs" isNumeric>{Number(r.actions).toLocaleString()}</Td>
              <Td fontSize="xs" isNumeric>{deltaCell(r.actions_delta_pct)}</Td>
              <Td fontSize="xs" isNumeric>{Number(r.customers).toLocaleString()}</Td>
              <Td fontSize="xs" isNumeric>{deltaCell(r.customers_delta_pct)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
